import { FaLinkedin, FaGithub, FaInstagram, FaYoutube, FaTelegram, FaBlogger } from 'react-icons/fa'
import { FiFile } from 'react-icons/fi';

const linkClass = "mx-2 first:ml-0 first:mr-2 text-lg w-7 h-7"
const iconClass = "text-slate-400 w-full h-full"

const SocialButtons = () => {
  return (
    <nav className="flex my-8" aria-label="Social profiles">
      <a
        href="https://www.linkedin.com/in/yusuf-fachroni/"
        className={`${linkClass} hover:text-blue-800`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni on LinkedIn"
      >
        <FaLinkedin className={`${iconClass} hover:text-blue-500`} />
      </a>
      <a
        href="https://t.me/stuckoverflow"
        className={`${linkClass} hover:text-blue-800`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni on Telegram"
      >
        <FaTelegram className={`${iconClass} hover:text-blue-400`} />
      </a>
      <a
        href="https://github.com/c0deslinger"
        className={`${linkClass} hover:text-black`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni on GitHub"
      >
        <FaGithub className={`${iconClass} hover:text-black`} />
      </a>
      <a
        href="https://instagram.com/_ahmedyusuf"
        className={`${linkClass} hover:text-pink-800`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni on Instagram"
      >
        <FaInstagram className={`${iconClass} hover:text-pink-500`} />
      </a>
      <a
        href="https://www.youtube.com/@MochammadYusufFachroni/videos"
        className={`${linkClass} hover:text-red-800`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni on YouTube"
      >
        <FaYoutube className={`${iconClass} hover:text-red-500`} />
      </a>
      <a
        href="https://yusuf-fachroni.blogspot.com/"
        className={`${linkClass} hover:text-red-800`}
        target="_blank"
        rel="noopener noreferrer me"
        aria-label="Yusuf Fachroni blog"
      >
        <FaBlogger className={`${iconClass} hover:text-orange-400`} />
      </a>
      <a
        href="/assets/doc/CV%20Flutter%20-%20Yusuf%20Fachroni.pdf"
        className="mx-2 text-lg w-6 h-6 hover:text-green-800"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download CV PDF"
      >
        <FiFile className={`${iconClass} hover:text-green-500`} />
      </a>
    </nav>
  )
}

export default SocialButtons
